import React, { Component } from 'react';
import PropTypes from 'prop-types';
import deepEqual from 'deep-equal';
import qs from 'qs';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import AccessorialRequestActionCreators from 'actions/AccessorialRequestActionCreators';
import JobDetailsHeader from 'components/modules/shipments/tracking/JobDetailsHeader';
import JobDetailsMenu from 'components/modules/shipments/tracking/JobDetailsMenu';
import AccessorialsConfirmationModal from 'components/modules/shipments/accessorials/ConfirmationModal';
import AccountingWebAPIUtils from 'utils/AccountingWebAPIUtils';
import SessionStore from 'stores/SessionStore';
import USER_ROLES from 'constants/UserRoles';
import ShipmentHolds from 'components/modules/shipments/ShipmentHolds';
import { isShipmentClosed } from 'helpers/shipments';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import Alert from 'components/ui/Alert';
import { withTranslation } from 'react-i18next';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import JobDetailsMenuItem from './JobDetailsMenuItem';
import JobDetailCard from './JobDetailCard';
import JobAdmin from './Admin';
import JobStatus from './JobStatus';
import CostSummary from './CostSummary';
import ShareModal from './ShareModal';
import ViewAccessorialRequests from '../ViewAccessorialRequests';
import LabelValue from '../../../ui/tailwind/label-value';
import { FEATURE_FLAG_ENABLED_BREADCRUMB } from 'constants/temp-feature-flag-breadcrumb';
const TABS = {
    JOB: 'job',
    STATUS: 'status',
    INVOICE: 'invoice',
    PAYOUT: 'payout',
    SUPPORT: 'support',
    ADMIN: 'admin',
};
const getInitialTab = (job, action = '') => {
    if (!job || action === 'accept' || action === 'set_dates') {
        return TABS.JOB;
    }
    if (action === 'payout') {
        return TABS.PAYOUT;
    }
    if (isShipmentClosed(job)) {
        return TABS.ADMIN;
    }
    if (job.status === 'accepted' || job.status === 'in_progress') {
        return TABS.ADMIN;
    }
    return TABS.JOB;
};
class JobDetails extends Component {
    static onClose() {
        ShipmentsActionCreators.closeTrackingShipmentDetails();
    }
    constructor(props) {
        super(props);
        this.defaultMenuItems = [
            {
                name: this.props.t('JOB'),
                sectionKey: TABS.JOB,
                iconClassName: 'fa-truck fa-flip-horizontal',
            },
            {
                name: this.props.t('STATUS'),
                sectionKey: TABS.STATUS,
                iconClassName: 'fa-clock-o',
            },
            {
                name: this.props.t('INVOICE', { count: 1 }),
                sectionKey: TABS.INVOICE,
                iconClassName: 'fa-usd',
            },
            {
                name: this.props.t('PAYOUT', { count: 1 }),
                sectionKey: TABS.PAYOUT,
                iconClassName: 'fa-usd',
            },
            {
                name: this.props.t('ADMIN'),
                sectionKey: TABS.ADMIN,
                iconClassName: 'fa-pencil',
            },
            {
                name: this.props.t('SUPPORT'),
                sectionKey: 'support',
                iconClassName: 'fa-question-circle',
            },
        ];
        this.setUserType = async () => {
            const user = SessionStore.getUser();
            const isShipper = SessionStore.isShipper();
            const isCarrier = SessionStore.isCarrier();
            if (user) {
                this.setState({
                    userRole: user._type,
                    isShipper,
                    isCarrier,
                });
            }
            const { job: { _id }, t, } = this.props;
            if (isShipper) {
                this.getInvoices(_id);
            }
            else {
                const grantedIds = await this.getUserGrantedIds(user._id);
                // Carrier can see own shipment or shipment of Carrier who granted access
                if (!((this.props.job.carrier && user._id === this.props.job.carrier._id) ||
                    (grantedIds && grantedIds.includes(this.props.job.carrier._id)))) {
                    this.setState((previousState) => (Object.assign(Object.assign({}, previousState), { notification: {
                            level: 'error',
                            title: t('JOB_ACCESS_DENIED_NOTIFICATION'),
                        } })));
                    setTimeout(() => {
                        window.location.href = `/shipments`;
                    }, 1500);
                }
                this.getPayouts(_id);
                if (grantedIds === null || grantedIds === void 0 ? void 0 : grantedIds.includes(this.props.job.carrier._id)) {
                    this.setState({ carrierPartner: this.props.job.carrier._id });
                    SessionStore.setCarrierPartner(this.props.job.carrier._id);
                }
            }
        };
        this.getUserGrantedIds = async (userId) => {
            try {
                const { data } = await UserWebAPIUtils.getAccountAccessRequests(userId);
                if (!data.length) {
                    return null;
                }
                return data
                    .filter((accountAccess) => accountAccess.grantee._id === userId &&
                    accountAccess.status === 'approved')
                    .map((accountAccess) => accountAccess.grantor._id);
            }
            catch (e) {
                console.log('Error getting grants', e);
            }
        };
        this.getInvoices = async (shipmentId) => {
            try {
                const result = await AccountingWebAPIUtils.getInvoicesForShipment(shipmentId);
                this.setState({ accountingDocs: result.entity.invoices });
            }
            catch (e) {
                console.log('Error getting invoices', e);
            }
        };
        this.getPayouts = async (shipmentId) => {
            try {
                const result = await AccountingWebAPIUtils.getPayoutsForShipment(shipmentId);
                this.setState({ accountingDocs: result.entity.payouts });
            }
            catch (e) {
                console.log('Error getting payouts', e);
            }
        };
        this.confirmAccessorialToRemove = (accessorial) => {
            this.setState({ selectedAccessorials: [accessorial._id] }, () => this.setState({ showAccessorialConfirmModal: true }));
        };
        this.handleMenuItemSelect = (currentlySelected) => {
            this.setState({ selectedSection: currentlySelected });
        };
        this.handleClose = () => {
            this.setState({ showModal: false });
        };
        this.handleOpen = () => {
            this.setState({ showModal: true });
        };
        this.handleRemoveAccessorial = (payload) => {
            AccessorialRequestActionCreators.declineAccessorials(payload);
            this.setState({ showAccessorialConfirmModal: false });
        };
        this.renderAccessorialConfirmationModal = () => {
            const { selectedAccessorials, showAccessorialConfirmModal } = this.state;
            if (!selectedAccessorials.length) {
                return null;
            }
            return (React.createElement(AccessorialsConfirmationModal, { show: showAccessorialConfirmModal, action: "decline_all", onHide: () => this.setState({ showAccessorialConfirmModal: false }), shipmentId: this.props.job._id, selectedAccessorials: selectedAccessorials, onAccessorialSubmit: this.handleRemoveAccessorial }));
        };
        this.renderShipmentStatus = () => {
            if (!this.props.job)
                return null;
            return (React.createElement("div", null,
                React.createElement(ShipmentHolds, { shipment: this.props.job }),
                React.createElement(JobStatus, { className: "job_detail_component", jobStatus: this.props.job.current_status, job: this.props.job, hideReason: false, hideAttachment: false })));
        };
        const menuItems = [...this.defaultMenuItems];
        const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        const selectedSection = getInitialTab(props.job, query.action);
        this.state = {
            menuItems,
            selectedSection,
            userRole: '',
            isShipper: false,
            isCarrier: false,
            showModal: false,
            showAccessorialConfirmModal: false,
            accountingDocs: [], // will hold invoices or payouts,
            carrierPartner: null, // Holds ID of current shipment's carrier
        };
    }
    componentDidMount() {
        this.setUserType();
    }
    shouldComponentUpdate(nextProps, nextState) {
        const isEqual = deepEqual(nextProps, this.props) && deepEqual(nextState, this.state);
        return !isEqual;
    }
    componentWillUnmount() {
        SessionStore.setCarrierPartner(null);
    }
    getCustomerReferenceNumber() {
        if (this.props.job.tracking_id) {
            return this.props.job.tracking_id;
        }
        return 'N/A';
    }
    invoiceEnabled() {
        return this.state.userRole !== USER_ROLES.CARRIER;
    }
    payoutEnabled() {
        return this.state.userRole !== USER_ROLES.SHIPPER;
    }
    isMenuItemVisible(menuItem) {
        switch (menuItem.sectionKey) {
            case 'invoice':
                return this.invoiceEnabled();
            case 'payout':
                return this.payoutEnabled();
            default:
                return true;
        }
    }
    isMenuItemActive(menuItem) {
        return this.state.selectedSection === menuItem.sectionKey;
    }
    getCostBody() {
        const { isShipper, isCarrier, accountingDocs, carrierPartner } = this.state;
        const { job } = this.props;
        return (React.createElement("div", null,
            React.createElement(CostSummary, { isShipper: isShipper, job: job, accountingDocs: accountingDocs }),
            isShipper && isIntermodalShipmentType(job) && (React.createElement(ViewAccessorialRequests, { isShipper: isShipper, isCarrier: isCarrier, job: job })),
            isCarrier && isIntermodalShipmentType(job) && (React.createElement(ViewAccessorialRequests, { isShipper: isShipper, isCarrier: isCarrier, job: job, removeAccessorial: this.confirmAccessorialToRemove, carrierPartner: carrierPartner }))));
    }
    renderInvoice() {
        if (this.state.selectedSection === 'invoice' && this.invoiceEnabled()) {
            return this.getCostBody();
        }
        return null;
    }
    renderPayout() {
        if (this.state.selectedSection === 'payout' && this.payoutEnabled()) {
            return this.getCostBody();
        }
        return null;
    }
    renderSupport() {
        const { t } = this.props;
        if (this.state.selectedSection === 'support') {
            return (React.createElement("div", { className: "p-4" },
                React.createElement("section", null,
                    React.createElement("h3", { className: "my-0 mb-4" }, t('SUPPORT')),
                    React.createElement(LabelValue, { icon: "mail", className: "mb-2" },
                        React.createElement("a", { href: `mailto:${SUPPORT_EMAIL_ADDRESS}` }, SUPPORT_EMAIL_ADDRESS)),
                    React.createElement(LabelValue, { icon: "phone", className: "mb-2" },
                        React.createElement("a", { href: `tel:${SUPPORT_PHONE_NUMBER}` }, SUPPORT_PHONE_NUMBER)))));
        }
        return null;
    }
    renderMenuItems() {
        return this.state.menuItems.map((menuItem, i) => {
            const visible = this.isMenuItemVisible(menuItem);
            const active = this.isMenuItemActive(menuItem);
            const mappedMenuItem = Object.assign(Object.assign({}, menuItem), { visible,
                active });
            return (React.createElement(JobDetailsMenuItem, { key: i, menuItem: mappedMenuItem, onSelectMenuItem: this.handleMenuItemSelect }));
        });
    }
    renderNotification() {
        const { notification } = this.state;
        if (!notification) {
            return null;
        }
        let bsStyle = '';
        if (notification.level === 'success') {
            bsStyle = 'success';
        }
        else if (notification.level === 'error') {
            bsStyle = 'error';
        }
        const { body, title } = notification;
        const text = body || title;
        return (React.createElement(Alert, { className: "mb-0", type: bsStyle, onDismiss: this.handleCloseNotification }, text));
    }
    render() {
        return (React.createElement("div", { className: "flex flex-col" },
            this.renderNotification(),
            React.createElement("div", { className: "flex flex-wrap" },
                React.createElement("div", { className: "job_details" },
                    React.createElement(JobDetailsHeader, { job: this.props.job, closeButtonVisible: this.props.closeButtonVisible, customerReferenceNumber: this.getCustomerReferenceNumber(), onOpenShare: this.handleOpen, onClose: JobDetails.onClose, isShipper: this.state.isShipper }),
                    React.createElement("div", { className: "job_details__wrapper" },
                        React.createElement(JobDetailsMenu, null, this.renderMenuItems()),
                        React.createElement("div", { className: "flex-1 job_details__content" },
                            this.state.selectedSection === 'job' && (React.createElement(JobDetailCard, { job: this.props.job, activeDriver: this.props.activeDriver, isShipper: this.state.isShipper, isCarrier: this.state.isCarrier })),
                            this.state.selectedSection === 'status' &&
                                this.renderShipmentStatus(),
                            this.renderInvoice(),
                            this.renderPayout(),
                            this.state.selectedSection === 'admin' && (React.createElement(JobAdmin, { job: this.props.job, isShipper: this.state.isShipper, isCarrier: this.state.isCarrier, drivers: this.props.drivers, activeDriver: this.props.activeDriver, cancelDisabled: this.props.job.accepted, goToPayouts: () => this.handleMenuItemSelect(TABS.PAYOUT), carrierPartner: this.state.carrierPartner })),
                            this.renderSupport()))),
                this.state.showModal && (React.createElement(ShareModal, { job: this.props.job, showModal: this.state.showModal, onCloseModal: this.handleClose })),
                this.state.showAccessorialConfirmModal &&
                    this.renderAccessorialConfirmationModal())));
    }
}
JobDetails.propTypes = {
    job: PropTypes.object.isRequired,
    drivers: PropTypes.array,
    activeDriver: PropTypes.shape({
        _id: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
    }),
    closeButtonVisible: PropTypes.bool,
};
JobDetails.defaultProps = {
    drivers: [],
    activeDriver: null,
    closeButtonVisible: true,
};
export default withTranslation()(JobDetails);
